import React, { useEffect } from 'react';
import { Modal, Typography } from 'antd';
import { interpolateString } from '@utils/string';
import { StatusCodes } from '@constants/enum/common';
import { EventControlApiKeysElement } from '@constants/event';
import { API_KEY_REVOCATION } from '@modules/APIKeys/constants/apiKeys';
import useApiKeys from '@modules/APIKeys/hooks/useApiKeys';
import { ApiKeyEventPayload, IApiKey } from '@modules/APIKeys/types/apiKeys';

interface IDeleteApiKeyModalProps {
  apiKey: IApiKey;
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
}

const { Paragraph, Text } = Typography;

const DeleteApiKeyModal: React.FC<IDeleteApiKeyModalProps> = ({
  apiKey,
  isOpen,
  loading,
  onClose,
}) => {
  const { deleteApiKey, deleteApiKeyStatus, trackApiKeyUserEvent } = useApiKeys();

  const handleDelete = async () => {
    const { api_token_id: apiKeyId } = apiKey;

    const userEvent: ApiKeyEventPayload = {
      event: EventControlApiKeysElement.REVOKE_KEY,
      properties: { api_token_id: apiKeyId },
    };

    await deleteApiKey(apiKeyId);
    await trackApiKeyUserEvent(userEvent);
  };

  useEffect(() => {
    if (deleteApiKeyStatus === StatusCodes.SUCCESS) {
      onClose();
    }
  }, [deleteApiKeyStatus]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={API_KEY_REVOCATION.MODAL_TITLE}
      okText={API_KEY_REVOCATION.BUTTON_LABEL}
      okButtonProps={{ onClick: handleDelete, loading: loading, danger: true }}
    >
      <Paragraph>
        {interpolateString(API_KEY_REVOCATION.CONFIRMATION, {
          api_key: <Text strong>{apiKey.masked_token}</Text>,
        })}
        <Text strong>{API_KEY_REVOCATION.WARNING}</Text>
      </Paragraph>
    </Modal>
  );
};

export default DeleteApiKeyModal;
